<template>
    <div class="contactDialog">
        <van-dialog v-model="visible" title=" "
                    :show-cancel-button="false"
        >
            <div>
                <div>
                    <img :src="dialogShowMessage.image" alt=""/>
                </div>

                <div>
                    <div class="msg-info">
                        <!--<van-icon name="phone-o" size="20" color="#2d8dfd" class="phoneIcon"/>-->
                        <span class="title">{{dialogShowMessage.msg.title}}</span>
                        <span>：</span>
                        <span class="value"><a :href="'tel:'+ dialogShowMessage.msg.value">{{dialogShowMessage.msg.value}}</a></span>
                    </div>
                </div>
            </div>
        </van-dialog>
    </div>

</template>

<script>
    export default {
        name: "contactDialog",
        props: {
            dialogShowMessage: {type: Object},
        },
        data () {
            return {
                visible: false,
            }
        },
        methods: {
            init () {
                this.visible = true;
            },
        }
    }
</script>

<style lang="scss">
    .contactDialog {
        .van-dialog__content {
            text-align: center;
            font-size: 14px;
            color: #666;
            padding-bottom: 15px;
        }

        img {
            width: 180px;
            height: 180px;
        }
        .msg-info {
            padding-top: 10px;

            .phoneIcon{
                vertical-align: middle;
                margin-top: -5px;
                margin-right: 5px;
            }

            .title {
                font-size: 20px;
                font-weight: 500;
                color: rgb(51, 51, 51);
            }

            .value {
                font-size: 20px;
                font-weight: 400;
                color: rgb(51, 51, 51);
            }
        }
    }
</style>
